<template>
  <span>
    <el-dropdown>
      <el-button type="primary">
        <span>{{ tip }}</span>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="exportOrders">批量{{ title }}</el-dropdown-item>
        <el-dropdown-item @click.native="viewOrdersList">{{ title }}任务列表</el-dropdown-item>
        <slot></slot>
      </el-dropdown-menu>
    </el-dropdown>
    <download-order-file-modal
      ref="file"
      :taskType="taskType" />
    <upload-new ref="uploadNew" />
  </span>
</template>
<script>
import FullscreenLoading from '@/utils/fullscreenLoading'
import DownloadOrderFileModal from './download-order-file-modal.vue'
import UploadNew from '@/components/upload-new.vue'
export default {
  name: 'DownloadButton',
  components: { DownloadOrderFileModal, UploadNew },
  props: {
    tip: { type: String, default: '下载' },
    type: { type: String, default: 'export' },
    beforeUpload: { type: Function, default: () => ({}) },
    taskType: { type: Number, default: 0 },
    fetchOrderCount: { type: Function, default: () => ({}) },
    createDownloadFile: { type: Function, default: () => ({}) },
    getQuery: { type: Function, default: () => ({}) },
    validate: { type: Function }
  },
  computed: {
    title({ type }) {
      return type === 'export' ? '导出' : '导入'
    }
  },
  methods: {
    uploadOrders() {
      this.beforeUpload()
        .then(options => {
          this.$refs.uploadNew.upload({ ...options }, (formData) => {
            FullscreenLoading.creatLoading('正在上传数据中...')
            this.createDownloadFile(formData)
              .then(res => {
                FullscreenLoading.destroyLoading()
                console.log(res)
                const { result, message } = res.data
                if (result === 0) {
                  this.$message.success('导入任务已创建，请稍后点击“导入任务列表”查看导入订单明细')
                } else {
                  this.$message.error(message)
                }
              })
              .catch(err => {
                FullscreenLoading.destroyLoading()
                this.$message.error(err.message)
              })
          })
        })
    },
    exportOrders() {
      if (this.type === 'upload') {
        this.uploadOrders()
        return
      }
      if (this.validate) {
        this.validate()
          .then(({ query, total }) => {
            const text = `当前已勾选${total}条订单记录, 是否继续导出?`
            this.$confirm(text, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
              .then(() => {
                this.createDownloadTask(query)
              })
          })
      } else {
        FullscreenLoading.creatLoading('查询导出数据中...')
        const query = this.getQuery()
        this.fetchOrderCount({ ...query, pageNum: 1, pageSize: 1 })
          .then(res => {
            FullscreenLoading.destroyLoading()
            const { result, message, total } = res.data
            if (result === 0) {
              const text = `当前查询条件下共${total}条订单记录, 是否继续导出?`
              this.$confirm(text, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
                .then(() => {
                  this.createDownloadTask(query)
                })
            } else if (result === 13) {
              this.$message.error('订单记录数为0，不可导出')
            } else {
              this.$message.error(message)
            }
          })
          .catch(err => {
            FullscreenLoading.destroyLoading()
            this.$message.error(err.message)
          })
      }
    },
    createDownloadTask(query) {
      FullscreenLoading.creatLoading('正在导出数据中...')
      this.createDownloadFile({ ...query, taskType: this.taskType })
        .then(res => {
          FullscreenLoading.destroyLoading()
          console.log(res)
          const { result, message } = res.data
          if (result === 0) {
            this.$message.success('导出任务已创建，请稍后点击“导出任务列表”查看下载订单明细')
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          FullscreenLoading.destroyLoading()
          this.$message.error(err.message)
        })
    },
    viewOrdersList() {
      this.$refs.file.fetch()
    }
  }
}
</script>
